import axios from "axios";

const base = process.env.REACT_APP_BACK_URL || `${window.location.protocol}//${window.location.hostname}:5000`;

const auth = (token: string) => ({
  headers: { Authorization: `Bearer ${token}` },
});

export type PuntoItem = {
  socio_puntos_id: number;
  socio_id: number;
  comercio: string;
  comercio_id?: number | null;
  puntos: number;
  fecha_carga: string;
};

export type PuntosSocioResponse = {
  socioId: number;
  totalPuntos: number;
  items: PuntoItem[];
};

export const getPuntosBySocio = async (socioId: number | string, token: string) => {
  const { data } = await axios.get<PuntosSocioResponse>(`${base}/socio/${socioId}/puntos`, auth(token));
  return data;
};
